//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from './../layouts/Header.vue'
import HeroAbout from './../components/HeroAbout.vue'
import Team from './../components/Team.vue'
import Footer from './../layouts/Footer.vue'

export default {
  name: 'about',
  components: {
    Header,
    HeroAbout,
    Team,
    Footer,
  },
  head: {
    title: 'About | Mazecare',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Meet the team behind mazecare.'
      }
    ],
  }
};
